import { ComponentNameEnum, DropdownOption } from '@/types';

const getImportZipFieldConfig = (defaultValue = '', displayVariables = false, variablesList: DropdownOption[] = []) => ({
  componentName: ComponentNameEnum.CUSTOM_HTML,
  options: {
    defaultValue,
    variablesList,
    displayVariables,
  },
});

export default getImportZipFieldConfig;
